/**
 * @author: subhasish.ghosh@zoom.us
 */

const colors = [
  "#a6cee3",
  "#b2df8a",
  "#fb9a99",
  "#fdbf6f",
  "#cab2d6",
  "#ffff99",
  "#1f78b4",
  "#33a02c",
];

const sankeyOptions = {
  height: 400,
  sankey: {
    node: {
      width: 20,
      labelPadding: 6,
      nodePadding: 10,
      colors: colors,
      interactivity: true,
      label: {
        fontSize: 12,
        color: "#384988",
        bold: true,
        italic: false,
      },
    },
    link: {
      color: {
        fillOpacity: 0.8,
        strokeWidth: 1,
      },
      colors: colors,
      colorMode: "gradient",
    },
  },
  tooltip: {
    isHtml: true,
    showColorCode: true,
    textStyle: {
      color: "#384988",
      fontSize: 12,
      bold: true,
    },
    trigger: "focus",
  },
};

export const sankeyColumns = [
  { type: "string", label: "From" },
  { type: "string", label: "To" },
  { type: "number", label: "Weight" },
  { type: "string", role: "tooltip", p: { html: true } },
];

export default sankeyOptions;
